import { Fragment } from 'react';
import CheckIcon from '@mui/icons-material/Check';
import { IconButton, Snackbar } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ErrorIcon from '@mui/icons-material/Error';
import InfoIcon from '@mui/icons-material/Info';
import WarningIcon from '@mui/icons-material/Warning';
import { SnackbarContext, SnackbarMessageType } from './snackbarContext';
import { useStyles } from './styles';

export const SharedSnackbar = () => {
  const classes = useStyles();

  return (
    <SnackbarContext.Consumer>
      {({ isOpen, message, type, close }) => {
        let Icon;
        let className;

        switch (type) {
          default:
          case SnackbarMessageType.INFO:
            Icon = InfoIcon;
            break;
          case SnackbarMessageType.SUCCESS:
            Icon = CheckIcon;
            className = classes.success;
            break;
          case SnackbarMessageType.WARN:
            Icon = WarningIcon;
            className = classes.warn;
            break;
          case SnackbarMessageType.ERROR:
            Icon = ErrorIcon;
            className = classes.error;
            break;
        }

        return (
          <Snackbar
            open={isOpen}
            onClose={close}
            message={
              <span className={classes.message} color='inherit'>
                <Icon className={classes.icon} color='inherit' />{' '}
                {message && message.split
                  ? message.split(/\n/).map((t, i, arr) => (
                      <Fragment key={`error-${i}`}>
                        {t}
                        {arr.length > 1 && <br />}
                      </Fragment>
                    ))
                  : null}
              </span>
            }
            autoHideDuration={6000}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
            action={
              <IconButton color='inherit' size='large' onClick={close}>
                <CloseIcon />
              </IconButton>
            }
            ContentProps={{ className }}
          />
        );
      }}
    </SnackbarContext.Consumer>
  );
};
